var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconWall = function SvgIconWall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3 4.25a1 1 0 0 0-1 1v13.5a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V5.25a1 1 0 0 0-1-1zm17 4.5h-7v-2.5h7zm0 2v2.5h-2.5v-2.5zm0 4.5h-7v2.5h7zm-9 2.5v-2.5H4v2.5zm-7-4.5h2.5v-2.5H4zm0-4.5h7v-2.5H4zm11.5 2v2.5h-7v-2.5z",
    clipRule: "evenodd"
  })));
};
export default SvgIconWall;